import React from "react";
import {catchError, switchMap, takeUntil, map, mergeMap} from "rxjs/operators";
import {ofType} from "redux-observable";
import {of} from 'rxjs';
import {ROUTE_CHANGED} from "../app/AppActions";
import {SESSION_EXPIRED} from "../login/LoginActions";
import {
    CREATE_OR_UPDATE_CREDIT_START,
    createOrUpdateCreditFulfilled,
    GET_CREDIT_DETAILS_START,
    getCreditDetailsFulfilled,
    getAvailablePlansFulfilled, //B
    getInvoicesFulfilled,
    TOGGLE_CREDIT_DETAILS,
    toggleCreditDetails,
    GET_PLANS_START, //
    getEmailPlansFulfilled,
    GET_EMAIL_PLANS_START,
    atachPlanToClientFulfilled,
    deletePlanFromClientFulfilled,
    deleteCreditFulfilled,
    DELETE_CREDIT_START,
    ATTACH_PLAN_TO_CLIENT_START,
    DETACH_PLAN_FROM_CLIENT_START,
    DELETE_PLANS_FROM_CLIENT_START,
    deletePlansFromClientFulfilled, CONFIRM_3D_SECURE_START, confirm3dSecureFulfilled, GET_INVOICES_START
} from "./BillingActions";

const getCreditDetailsEpic = (action$, state$, {sendGet}) => action$.pipe(
    ofType(GET_CREDIT_DETAILS_START),
    switchMap(action => sendGet('/api/payment/credit').pipe(
        map(response => getCreditDetailsFulfilled(response)),
        catchError(err => of(getCreditDetailsFulfilled(err, true))),
        takeUntil(action$.pipe(
            ofType(ROUTE_CHANGED, SESSION_EXPIRED)
        )),
    ))
);

const deleteCreditEpic = (action$, state$, {sendDelete}) => action$.pipe(
    ofType(DELETE_CREDIT_START),
    switchMap(action => sendDelete(`/api/payment/credit?last4digits=${action.payload}`).pipe(
        mergeMap(response => of(
            deleteCreditFulfilled(response)),
            toggleCreditDetails(),
        ),
        catchError(err => of(deleteCreditFulfilled(err, true))),
        takeUntil(action$.pipe(
            ofType(ROUTE_CHANGED, SESSION_EXPIRED, TOGGLE_CREDIT_DETAILS)
        )),
    ))
);

const createOrUpdateCreditEpic = (action$, state$, {sendPost}) => action$.pipe(
    ofType(CREATE_OR_UPDATE_CREDIT_START),
    switchMap(action => sendPost('/api/payment/creditsubscribe', action.payload.info, {email: action.payload.email}).pipe(
        mergeMap(response => of(
            createOrUpdateCreditFulfilled(response)),
            toggleCreditDetails(),
        ),
        catchError(err => of(createOrUpdateCreditFulfilled(err, true))),
        takeUntil(action$.pipe(
            ofType(ROUTE_CHANGED, SESSION_EXPIRED, TOGGLE_CREDIT_DETAILS)
        )),
    ))
);

//B 
const getPlansEpic = (action$, state$, {sendGet}) => action$.pipe(
    ofType(GET_PLANS_START),
    switchMap(action => sendGet('/api/premium/email/plans/available', action.payload.info, {email: action.payload.email}).pipe(
        map(response => getAvailablePlansFulfilled(response)),
        catchError(err => of(getAvailablePlansFulfilled(err, true))),
        takeUntil(action$.pipe(
            ofType(ROUTE_CHANGED, SESSION_EXPIRED)
        )),
    ))
);

const getInvoicesEpic = (action$, state$, {sendGet}) => action$.pipe(
    ofType(GET_INVOICES_START),
    switchMap(action => sendGet('/api/premium/email/invoices', action.payload.info, {email: action.payload.email}).pipe(
        map(response => getInvoicesFulfilled(response)),
        catchError(err => of(getInvoicesFulfilled(err, true))),
        takeUntil(action$.pipe(
            ofType(ROUTE_CHANGED, SESSION_EXPIRED)
        )),
    ))
);

//B 
const getEmailPlansEpic = (action$, state$, {sendGet}) => action$.pipe(
    ofType(GET_EMAIL_PLANS_START),
    switchMap(action => sendGet('/api/premium/email/plans', action.payload.info).pipe(
        map(response => getEmailPlansFulfilled(response)),
        catchError(err => of(getEmailPlansFulfilled(err, true))),
        takeUntil(action$.pipe(
            ofType(ROUTE_CHANGED, SESSION_EXPIRED)
        )),
    ))
);

//B 
const attachPlanToClientEpic = (action$, state$, {sendPost}) => action$.pipe(
    ofType(ATTACH_PLAN_TO_CLIENT_START),
    switchMap(action => sendPost('/api/premium/email/subscription', [{id: action.payload.planId}]).pipe(
        map(response => atachPlanToClientFulfilled(response)),
        catchError(err => of(atachPlanToClientFulfilled(err, true))),
        takeUntil(action$.pipe(
            ofType(ROUTE_CHANGED, SESSION_EXPIRED)
        )),
    ))
);

//B 
const deletePlanFromClientEpic = (action$, state$, {sendPost}) => action$.pipe(
    ofType(DETACH_PLAN_FROM_CLIENT_START),
    switchMap(action => sendPost('/api/premium/email/subscription', []).pipe(
        map(response => deletePlanFromClientFulfilled(response)),
        catchError(err => of(deletePlanFromClientFulfilled(err, true))),
        takeUntil(action$.pipe(
            ofType(ROUTE_CHANGED, SESSION_EXPIRED)
        )),
    ))
);

const deletePlansFromClientEpic = (action$, state$, {sendPost}) => action$.pipe(
    ofType(DELETE_PLANS_FROM_CLIENT_START),
    switchMap(action => sendPost('/api/premium/email/subscription/cancelAll', []).pipe(
        map(response => deletePlansFromClientFulfilled(response)),
        catchError(err => of(deletePlansFromClientFulfilled(err, true))),
        takeUntil(action$.pipe(
            ofType(ROUTE_CHANGED, SESSION_EXPIRED)
        )),
    ))
);

const confirm3dSecureEpic = (action$, state$, {sendPost}) => action$.pipe(
    ofType(CONFIRM_3D_SECURE_START),
    switchMap(action => sendPost('/api/payment/confirmation/email/' + action.payload.email, [{subId: action.payload.subId}]).pipe(
        map(response => confirm3dSecureFulfilled(response)),
        catchError(err => of(confirm3dSecureFulfilled(err, true))),
        takeUntil(action$.pipe(
            ofType(ROUTE_CHANGED, SESSION_EXPIRED)
        )),
    ))
);

//getPlansEpic
export default [getCreditDetailsEpic, createOrUpdateCreditEpic, getPlansEpic, attachPlanToClientEpic, getEmailPlansEpic,
    deletePlanFromClientEpic, deleteCreditEpic, deletePlansFromClientEpic, confirm3dSecureEpic, getInvoicesEpic]



// WEBPACK FOOTER //
// ./src/containers/billing/BillingsEpics.js